CustomTC.define('jquery/manipulation/var/rcheckableType',[],function() {
	return (/^(?:checkbox|radio)$/i);
});

